<script>
  import AreaChartTool from "./AreaChartTool.svelte";
  import { Theme, FontsUrban } from "@urbaninstitute/dataviz-components";
</script>

<svelte:options customElement={{ tag: "data-tool" }} />

<FontsUrban />
<Theme>
  <AreaChartTool />
</Theme>
